document.addEventListener('DOMContentLoaded', async () => {
  // Espera o componente do tema estar registrado
  if (window.customElements && customElements.get('variant-picker')) {
    await customElements.whenDefined('variant-picker');
  }

  // Dá 1 frame para o tema terminar a seleção inicial
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.querySelectorAll('variant-picker').forEach((picker) => {
        picker.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');

          input.dataset.currentChecked = 'false';
          input.dataset.previousChecked = 'false';
        });

        picker.dataset.variantManuallySelected = 'false';
      });
    });
  });

  // Quando o cliente selecionar uma variante
  document.addEventListener('change', (event) => {
    const input = event.target.closest(
      'variant-picker input[type="radio"]'
    );

    if (!input) return;

    const picker = input.closest('variant-picker');

    if (!picker) return;

    picker.dataset.variantManuallySelected = 'true';

    const error = picker.querySelector('.variant-select-error');

    if (error) {
      error.remove();
    }
  });

  // Validação ao tentar comprar
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        'button[name="add"], button[type="submit"], [data-add-to-cart]'
      );

      if (!button) return;

      // Ignora submits que claramente não são do produto
      if (button.closest('variant-picker')) return;

      const section =
        button.closest('.shopify-section') ||
        button.closest('[data-section-id]');

      if (!section) return;

      const picker = section.querySelector('variant-picker');

      if (!picker) return;

      const fieldsets = picker.querySelectorAll(
        '.variant-picker__form fieldset'
      );

      if (!fieldsets.length) return;

      let missingOption = false;

      fieldsets.forEach((fieldset) => {
        const selected = fieldset.querySelector(
          'input[type="radio"]:checked'
        );

        if (!selected) {
          missingOption = true;
        }
      });

      if (!missingOption) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      let error = picker.querySelector('.variant-select-error');

      if (!error) {
        error = document.createElement('p');
        error.className = 'variant-select-error';
        error.textContent = 'Selecione uma opção antes de adicionar ao carrinho.';

        picker.appendChild(error);
      }

      picker.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    },
    true
  );
});

const menuMobile = [
    {
        name: "Rastrear Pedido",
        icon: "https://cdn.shopify.com/s/files/1/0731/0370/4175/files/truck.png?v=1785592435",
        href: "#"
    },
    {
        name: "Grupo VIP",
        icon: "https://cdn.shopify.com/s/files/1/0731/0370/4175/files/whatsapp.png?v=1785592435",
        href: "#"
    },
    {
        name: "Atendimento",
        icon: "https://cdn.shopify.com/s/files/1/0731/0370/4175/files/question.png?v=1785592435",
        href: "#"
    }
];

document.addEventListener('click', function (e) {
    const button = e.target.closest('#checkout');

    if (!button) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    window.location.href = '/cart';
}, true); // <- captura o evento antes do tema

/* document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('#checkout');

    if (!btn || !window.yampiCheckoutUrl) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    window.location.href = window.yampiCheckoutUrl;
  },
  true
); */
/* 
document.addEventListener(
  "click",
  function (e) {
 const btn = e.target.closest('#checkout');

    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    window.location.href = "/cart?redirect=yampi";
  },
  true
);

(function () {

    const params = new URLSearchParams(window.location.search);

    if (params.get("redirect") !== "yampi") return;

    let tries = 0;

    const timer = setInterval(function () {

        if (window.yampiCheckoutUrl) {

            clearInterval(timer);

            window.location.href = window.yampiCheckoutUrl;

            return;
        }

        if (++tries > 50) {
            clearInterval(timer);
            console.error("Yampi não gerou o checkout.");
        }

    }, 200);

})();*/